<template>
  <Loader v-if="loader" />
  <div class="card">
    <h3>Dashboard Fatturazione Gas</h3>
    
    <div class="grid">
      <div class="col-12">
        <div class="p-card p-4 mb-3">
          <h4>Statistiche Per Mese</h4>
          <DataTable :value="statisticheMese" class="p-datatable-sm statistiche-table" responsiveLayout="scroll"
                   stripedRows :paginator="statisticheMese.length > 10" :rows="10"
                   selectionMode="single" @row-click="onMeseRowClick" v-tooltip.top="'Clicca sulla riga per vedere le fatture del mese'">
            <Column field="mese_fatturazione" header="Mese" 
                    class="column-text"
                    headerStyle="text-align: left; padding-left: 1rem" 
                    bodyStyle="text-align: left; padding-left: 1rem">
            </Column>
            <Column field="quanti" header="Nr. Fatture" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
            </Column>
            <Column field="totale" header="Totale" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.totale) }}
              </template>
            </Column>
            <ColumnGroup type="footer">
              <Row>
                <Column footer="Totale:" footerStyle="text-align: left; padding-left: 1rem; font-weight: bold" />
                <Column :footer="getTotaleFattureMesi()" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
                <Column :footer="formatCurrency(getTotaleMesi())" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
              </Row>
            </ColumnGroup>
          </DataTable>
        </div>
        
        <div class="p-card p-4 mb-3">
          <h4>Statistiche Per Tipo Pagamento</h4>
          <DataTable :value="statistichePagamento" class="p-datatable-sm statistiche-table" responsiveLayout="scroll"
                   stripedRows :paginator="statistichePagamento.length > 10" :rows="10"
                   selectionMode="single" @row-click="onPagamentoRowClick" v-tooltip.top="'Clicca sulla riga per vedere le fatture con questo tipo di pagamento'"
                   :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
            <Column field="name" header="Tipo Pagamento" 
                    class="column-text"
                    headerStyle="text-align: left; padding-left: 1rem" 
                    bodyStyle="text-align: left; padding-left: 1rem">
            </Column>
            <Column field="consumo" header="Tipo Consumo" 
                    class="column-text"
                    headerStyle="text-align: left; padding-left: 1rem" 
                    bodyStyle="text-align: left; padding-left: 1rem">
            </Column>
            <Column field="quanti" header="Nr. Fatture" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
            </Column>
            <Column field="totale" header="Totale" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.totale) }}
              </template>
            </Column>
            <ColumnGroup type="footer">
              <Row>
                <Column footer="Totale:" colspan="2" footerStyle="text-align: left; padding-left: 1rem; font-weight: bold" />
                <Column :footer="getTotaleFatturePagamento()" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
                <Column :footer="formatCurrency(getTotalePagamento())" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
              </Row>
            </ColumnGroup>
          </DataTable>
        </div>
        
        <div class="p-card p-4 mb-3">
          <h4>Statistiche Per Agente</h4>
          <DataTable :value="statisticheAgente" class="p-datatable-sm statistiche-table" responsiveLayout="scroll"
                   stripedRows :paginator="statisticheAgente.length > 10" :rows="10"
                   selectionMode="single" @row-click="onAgenteRowClick" v-tooltip.top="'Clicca sulla riga per vedere i rappresentanti e le fatture dell\'agente'"
                   :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
            <Column field="agente" header="Agente" 
                    class="column-text"
                    headerStyle="text-align: left; padding-left: 1rem" 
                    bodyStyle="text-align: left; padding-left: 1rem">
              <template #body="slotProps">
                <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.id)" class="clickable-link">{{ slotProps.data.agente }}</a>
              </template>
            </Column>
            <Column field="quanti" header="Nr. Fatture" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
            </Column>
            <Column field="totale" header="Totale" 
                    class="column-number"
                    headerStyle="text-align: right; padding-right: 1rem" 
                    bodyStyle="text-align: right; padding-right: 1rem">
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.totale) }}
              </template>
            </Column>
            <ColumnGroup type="footer">
              <Row>
                <Column footer="Totale:" footerStyle="text-align: left; padding-left: 1rem; font-weight: bold" />
                <Column :footer="getTotaleFattureAgenti()" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
                <Column :footer="formatCurrency(getTotaleAgenti())" footerStyle="text-align: right; padding-right: 1rem; font-weight: bold" />
              </Row>
            </ColumnGroup>
          </DataTable>
        </div>
      </div>
    </div>

    <!-- Dialog Mese -->
    <Dialog v-model:visible="meseDialogVisible" :header="'Fatture del mese di ' + nomeMeseSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">
      <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>
      <DataTable :value="dialogFattureFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="dialogFattureFiltered.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
        <Column field="numero" header="Numero" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
          </template>
        </Column>
        <Column field="ragsoc" header="Cliente" headerStyle="width: 25%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Mese"></Column>
        <Column field="consumo" header="Consumo" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="pay" header="Pagamento" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="agente" header="Agente" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId)" class="clickable-link">{{ slotProps.data.agente }}</a>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
          </template>
        </Column>
        <Column field="consumo_annuo" header="Consumo Annuo" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>

        <Column field="totale" header="Totale" headerStyle="width: 10%; text-align: right" bodyStyle="text-align: right">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.totale) }}
          </template>
        </Column>
      </DataTable>
    </Dialog>

    <!-- Dialog Pagamento -->
    <Dialog v-model:visible="pagamentoDialogVisible" :header="'Fatture con pagamento ' + nomePagamentoSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">
      <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>
      <DataTable :value="dialogFattureFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="dialogFattureFiltered.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
        <Column field="numero" header="Numero">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
          </template>
        </Column>
        <Column field="ragsoc" header="Cliente">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Mese"></Column>
        <Column field="consumo" header="Consumo"></Column>
        <Column field="pay" header="Pagamento"></Column>
        <Column field="agente" header="Agente">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId)" class="clickable-link">{{ slotProps.data.agente }}</a>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
          </template>
        </Column>
        <Column field="totale" header="Totale">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.totale) }}
          </template>
        </Column>
      </DataTable>
    </Dialog>

    <!-- Dialog Agente -->
    <Dialog v-model:visible="agenteDialogVisible" :header="'Rappresentanti dell\'agente ' + nomeAgenteSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">
      <div>
        <div class="filter-buttons mb-3">
          <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
          <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
          <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
        </div>
        <h5>Rappresentanti</h5>
        <DataTable :value="statisticheRappresentanti" class="p-datatable-sm mb-4" responsiveLayout="scroll"
                  stripedRows :paginator="statisticheRappresentanti.length > 10" :rows="10"
                  selectionMode="single" @row-click="onRappresentanteRowClick"
                  :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
          <Column field="rappresentante" header="Rappresentante" headerStyle="width: 60%; text-align: left" bodyStyle="text-align: left">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
            </template>
          </Column>
          <Column field="quanti" header="Nr. Fatture" headerStyle="width: 20%; text-align: right" bodyStyle="text-align: right"></Column>
          <Column field="totale" header="Totale" headerStyle="width: 20%; text-align: right" bodyStyle="text-align: right">
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.totale) }}
            </template>
          </Column>
        </DataTable>
        
        <h5>Fatture dell'agente</h5>
        <DataTable :value="datiFattureAgenteFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                  stripedRows :paginator="datiFattureAgenteFiltered.length > 10" :rows="10"
                  :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
          <Column field="numero" header="Numero" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
            </template>
          </Column>
          <Column field="ragsoc" header="Cliente" headerStyle="width: 25%; text-align: left" bodyStyle="text-align: left">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
            </template>
          </Column>
          <Column field="mese_fatturazione" header="Mese"></Column>
          <Column field="consumo" header="Consumo" headerStyle="width: 10%; text-align: right" bodyStyle="text-align: right"></Column>
          <Column field="pay" header="Pagamento" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left"></Column>
          <Column field="rappresentante" header="Rappresentante" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
            </template>
          </Column>
          <Column field="consumo_annuo" header="Consumo Annuo" headerStyle="width: 10%; text-align: right" bodyStyle="text-align: right"></Column>
          <Column field="totale" header="Totale" headerStyle="width: 10%; text-align: right" bodyStyle="text-align: right">
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.totale) }}
            </template>
          </Column>
        </DataTable>
      </div>
    </Dialog>

    <!-- Dialog Rappresentante -->
    <Dialog v-model:visible="rappresentanteDialogVisible" :header="'Fatture del rappresentante ' + nomeRappresentanteSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">
      <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>
      <DataTable :value="datiFattureRappresentanteFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="datiFattureRappresentanteFiltered.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
        <Column field="numero" header="Numero" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
          </template>
        </Column>
        <Column field="ragsoc" header="Cliente" headerStyle="width: 25%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Mese"></Column>
        <Column field="consumo" header="Consumo" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="pay" header="Pagamento" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="totale" header="Totale" headerStyle="width: 10%; text-align: right" bodyStyle="text-align: right">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.totale) }}
          </template>
        </Column>
      </DataTable>
    </Dialog>
  </div>
</template>

<script>
import Service from '@/services/ask-fatturazione/fatturazione-service'
import { ref, getCurrentInstance, onMounted, computed } from 'vue';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
    setup() {
      const loader = ref(false);
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus;
      self.$http = self.appContext.config.globalProperties.$http;
      const service = new Service(self.$http, self.$eventBus);
      const toast = useToast();
      
      const toastLifetime = 3000;
      
      const showToast = (severity, summary, detail) => {
        toast.add({
          severity,
          summary,
          detail,
          life: toastLifetime,
          closable: true
        });
      };

      const statisticheMese = ref([]);
      const statisticheAgente = ref([]);
      const statistichePagamento = ref([]);
      const statisticheRappresentanti = ref([]);
      const datiFatture = ref([]);
      const datiFattureAgente = ref([]);
      const datiFattureRappresentante = ref([]);
      
      const meseDialogVisible = ref(false);
      const pagamentoDialogVisible = ref(false);
      const agenteDialogVisible = ref(false);
      const rappresentanteDialogVisible = ref(false);
      
      const nomeMeseSelezionato = ref('');
      const nomePagamentoSelezionato = ref('');
      const nomeAgenteSelezionato = ref('');
      const nomeRappresentanteSelezionato = ref('');
      
      const selectedConsumo = ref(null);
      const selectedTypePay = ref(null);
      const selectedMese = ref(null);
      const selectedAgente = ref(null);
      const selectedRappresentante = ref(null);
      const dialogConsumoFilter = ref(null);

      const navigateToAgenteDetail = (agenteId) => {
        if (!agenteId) {
          showToast('warn', 'Attenzione', 'ID agente non disponibile');
          return;
        }
        window.open(`/ask/agenti/${agenteId}/dettagli`);
      };
      
      const navigateToRappresentanteDetail = (rappresentanteId) => {
        if (!rappresentanteId) {
          showToast('warn', 'Attenzione', 'ID rappresentante non disponibile');
          return;
        }
        window.open(`/ask/rappresentanti/${rappresentanteId}/dettagli`);
      };
      
      const navigateToFatturaDetail = (numero) => {
        if (!numero) {
          showToast('warn', 'Attenzione', 'Numero fattura non disponibile');
          return;
        }
        window.open(`/ask/clienti/fatture/${numero}/dettagli`);
      };
      
      const navigateToClienteDetail = (clienteId) => {
        if (!clienteId) {
          showToast('warn', 'Attenzione', 'ID cliente non disponibile');
          return;
        }
        window.open(`/ask/clienti/${clienteId}/dettagli`);
      };

      const loadAllData = async () => {
        try {
          loader.value = true;
          await Promise.all([
            loadStatistichePerMese(),
            loadStatisticheByPagamento(),
            loadStatisticheByAgente()
          ]);
          showToast('success', 'Successo', 'Dati caricati correttamente');
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati');
        } finally {
          loader.value = false;
        }
      };

      const loadStatistichePerMese = async () => {
        try {
          loader.value = true;
          const response = await service.getGasStatistichePerMese(selectedConsumo.value);
          statisticheMese.value = response;
          showToast('success', 'Successo', 'Statistiche per mese caricate');
          return response;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento delle statistiche per mese');
          return [];
        } finally {
          loader.value = false;
        }
      };

      const loadStatisticheByPagamento = async () => {
        const response = await service.getGasStatisticheByPagamento(selectedConsumo.value);
        statistichePagamento.value = response;
        return response;
      };

      const loadStatisticheByAgente = async () => {
        const response = await service.getGasStatisticheByAgente(selectedConsumo.value, selectedTypePay.value);
        statisticheAgente.value = response;
        return response;
      };

      const onMeseRowClick = async (event) => {
        try {
          loader.value = true;
          selectedMese.value = event.data.mese_fatturazione;
          nomeMeseSelezionato.value = event.data.mese_fatturazione;
          
          const response = await service.getGasDataByMese(event.data.mese_fatturazione, selectedConsumo.value);
          datiFatture.value = response;
          
          meseDialogVisible.value = true;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati del mese');
        } finally {
          loader.value = false;
        }
      };

      const onPagamentoRowClick = async (event) => {
        try {
          loader.value = true;
          selectedTypePay.value = event.data.id;
          nomePagamentoSelezionato.value = event.data.name;
          
          const response = await service.getGasDataByPay(event.data.id, selectedConsumo.value);
          datiFatture.value = response;
          
          pagamentoDialogVisible.value = true;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati del pagamento');
        } finally {
          loader.value = false;
        }
      };

      const onAgenteRowClick = async (event) => {
        try {
          loader.value = true;
          selectedAgente.value = event.data.id;
          nomeAgenteSelezionato.value = event.data.agente;
          
          const [responseRappresentanti, responseFatture] = await Promise.all([
            service.getGasStatisticheRappresentantiByAgente(event.data.id, selectedConsumo.value, selectedTypePay.value),
            service.getGasDataByAgente(event.data.id, selectedConsumo.value, selectedTypePay.value)
          ]);
          
          statisticheRappresentanti.value = responseRappresentanti;
          datiFattureAgente.value = responseFatture;
          
          agenteDialogVisible.value = true;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati dell\'agente');
        } finally {
          loader.value = false;
        }
      };

      const onRappresentanteRowClick = async (event) => {
        try {
          loader.value = true;
          selectedRappresentante.value = event.data.cod_rapp;
          nomeRappresentanteSelezionato.value = event.data.rappresentante;
          
          const response = await service.getGasDataByRappresentante(
            event.data.cod_rapp,
            selectedAgente.value,
            selectedConsumo.value,
            selectedTypePay.value
          );
          
          datiFattureRappresentante.value = response;
          rappresentanteDialogVisible.value = true;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati del rappresentante');
        } finally {
          loader.value = false;
        }
      };

      const getTotaleMesi = () => {
        return statisticheMese.value.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };

      const getTotaleFattureMesi = () => {
        return statisticheMese.value.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };

      const getTotalePagamento = () => {
        return statistichePagamento.value.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };

      const getTotaleFatturePagamento = () => {
        return statistichePagamento.value.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };

      const getTotaleAgenti = () => {
        return statisticheAgente.value.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };

      const getTotaleFattureAgenti = () => {
        return statisticheAgente.value.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };

      const applyConsumoFilter = (consumo) => {
        selectedConsumo.value = consumo;
        loadAllData();
      };

      const applyDialogConsumoFilter = (consumo) => {
        dialogConsumoFilter.value = consumo;
      };

      const formatCurrency = (value) => {
        return parseFloat(value).toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      const dialogFattureFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFatture.value;
        return datiFatture.value.filter(item => 
          item.cod_type_consumo === dialogConsumoFilter.value || 
          item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });

      const datiFattureAgenteFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFattureAgente.value;
        return datiFattureAgente.value.filter(item => 
          item.cod_type_consumo === dialogConsumoFilter.value || 
          item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });

      const datiFattureRappresentanteFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFattureRappresentante.value;
        return datiFattureRappresentante.value.filter(item => 
          item.cod_type_consumo === dialogConsumoFilter.value || 
          item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });

      const getConsumoName = (id) => {
        if (id === '1') return 'Acconto';
        if (id === '2') return 'Effettivo';
        return 'Sconosciuto';
      };

      const getRowColor = (item) => {

        if (!item.consumo_annuo || item.consumo_annuo <= 0) return 'white';
        
        if (item.preview_totale_qta_nostorno > item.consumo_annuo) {
          return '#FA585899';
        }
        if (item.preview_totale_qta_nostorno > (item.consumo_annuo / 2)) {
          return 'orange';
        }
        if (item.preview_totale_qta_nostorno > (item.consumo_annuo / 5)) {
          return 'yellow';
        }
        
        return 'white';
      };

      onMounted(() => {
        loadAllData();
      });

      return { 
        loader,
        statisticheMese,
        statisticheAgente,
        statistichePagamento,
        statisticheRappresentanti,
        datiFatture,
        datiFattureAgente,
        datiFattureRappresentante,
        meseDialogVisible,
        pagamentoDialogVisible,
        agenteDialogVisible,
        rappresentanteDialogVisible,
        nomeMeseSelezionato,
        nomePagamentoSelezionato,
        nomeAgenteSelezionato,
        nomeRappresentanteSelezionato,
        selectedConsumo,
        dialogConsumoFilter,
        
        formatCurrency,
        navigateToAgenteDetail,
        navigateToRappresentanteDetail,
        navigateToFatturaDetail,
        navigateToClienteDetail,
        onMeseRowClick,
        onPagamentoRowClick,
        onAgenteRowClick,
        onRappresentanteRowClick,
        applyConsumoFilter,
        applyDialogConsumoFilter,
        getTotaleMesi,
        getTotaleFattureMesi,
        getTotalePagamento,
        getTotaleFatturePagamento,
        getTotaleAgenti,
        getTotaleFattureAgenti,
        
        dialogFattureFiltered,
        datiFattureAgenteFiltered,
        datiFattureRappresentanteFiltered,
        getRowColor
      };
    }
}
</script>

<style scoped>
.card {
  background-color: #f4f4f4;
  padding: 16px;
  border-radius: 4px;
}

.p-card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  cursor: pointer;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background-color: #e9ecef !important;
}

.filter-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.clickable-link {
  color: #2196F3;
  text-decoration: none;
  font-weight: 500;
}

.clickable-link:hover {
  text-decoration: underline;
  color: #0D47A1;
}

:deep(.p-datatable .p-datatable-header) {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

:deep(.p-datatable .p-datatable-footer) {
  background-color: #f8f9fa;
  font-weight: 600;
  border-top: 1px solid #dee2e6;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
}

:deep(.p-dialog .p-dialog-header) {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.h-full {
  height: 100%;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

:deep(.p-datatable) {
  .p-datatable-thead > tr > th,
  .p-datatable-tbody > tr > td {
    padding: 0.5rem 1rem;
  }

  .p-column-title,
  .p-column-header-content {
    width: 100%;
    text-align: inherit;
  }

  .column-number {
    text-align: right !important;
  }

  .column-text {
    text-align: left !important;
  }

  .p-datatable-footer {
    padding: 0.5rem 1rem;
  }
}

:deep(.statistiche-table) {
  .p-datatable-wrapper {
    margin-bottom: 0;
  }

  .p-column-header-content {
    justify-content: inherit;
  }
}

:deep(.colored-row) {
  &.white {
    background-color: white !important;
  }
  
  &.yellow {
    background-color: #FFF9C4 !important;
  }
  
  &.orange {
    background-color: #FFE0B2 !important;
  }
  
  &[class*='#FA585899'] {
    background-color: #FFCDD2 !important;
  }
}

:deep(.p-datatable .p-datatable-tbody > tr.colored-row:hover) {
  background-color: inherit !important;
  opacity: 0.85;
}
</style>